export default {
  appName: "Supporters group for Governor Umo Eno",
  domain: process.env.NODE_ENV === 'production' ? "https://support.umoeno.com" : "http://127.0.0.1:8000",
  localUserKey: "dfb1c198005941d5b2a0_utk",
}
  